// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simulator-badge {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px 0 0 16px;
  font-size: 13px;
  background: var(--ion-color-warning);
  color: var(--ion-color-warning-contrast);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

@media (min-width: 992px) {
  .simulator-badge {
    right: 270px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,oCAAA;EACA,wCAAA;EACA,wCAAA;AAAF;;AAIA;EACE;IACE,YAAA;EADF;AACF","sourcesContent":["\n.simulator-badge {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 100000;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 16px 0 0 16px;\n  font-size: 13px;\n  background: var(--ion-color-warning);\n  color: var(--ion-color-warning-contrast);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n// wide screens: the admin menu is always visible on the right, the badge stays at the edge of the page\n@media (min-width: 992px) {\n  .simulator-badge {\n    right: 270px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
